<app-header></app-header>
<div class="other-Page container">
    <h3>FAQ</h3>

    <h4>Who can subscribe to Gamez Klub</h4>
    <p>Gamez Klub is mobile gaming service and any age group of users access this service and play the games.</p>

    <h4>What do I get when I subscribe to the Gamez Klub subscription!</h4>
    <p>With the Gamez Klub subscription, you can get unlimited access to play all the games within the subscription
        period.</p>

    <h4>How do I subscribe to the Gamez Klub service?</h4>
    <p>It is very simple to subscribe to the service. Simply visit the gamezklub.com service portal, click on any game
        icon that you like. You will then be prompted to subscribe. Simply follow the prompts to get subscribed.</p>

    <h4>How much does the subscription cost?</h4>
    <p>The subscription is priced at 1 Day Free Trial, KES10/day (Inc. VAT). Once subscribed you can play all games
        within the service at no extra charge*. *The Gamez Klub portal is free to browse but normal network data rates
        apply to stream videos.</p>

    <h4>What types of games can I play?</h4>
    <p>As a subscribed customer, you can play unlimited games you want within the service.</p>

    <h4>How do I download games onto my handset?</h4>
    <p>Gamez Klub is a gaming service which means you cannot download the games onto your handset.</p>

    <h4>Is there any limit to the number of games I can play?</h4>
    <p>There is no limit. You can play as many games as you like.</p>

    <h4>How do I play games on my handset?</h4>
    <p>Once you are subscribed to the Gamez Klub service, just select the game you want to play. Once you click on the
        game
        icon, the game should load and start to play (assuming you have enough signal to play the video).</p>


    <h4>How do I unsubscribe from the service?</h4>
    <p>Go to the “My Account” section that can be found in the menu in Safaricom live! Once in My Account click on My
        Subscriptions, find your subscription to Gamez Klub and simply click the “Cancel” button option. Your
        subscription
        will then be deactivated.</p>

    <h4>What is the customer care contact number?</h4>
    <p>Simply dial 082 111 from your Safaricom number.</p>

    <h4>How much do I pay for each game?</h4>
    <p>There is no additional game cost outside of the subscription. You can play all the games you want if you are
        already
        subscribed to the service. There are no data charges to browse the Gamez Klub portal, however, normal network
        data
        rates apply to play on browser.</p>

    <h4>Will there be other charges besides my subscription?</h4>
    <p>There are no additional charges to access all videos within the service. *There are no data charges to browse the
        Gamez Klub portal, however, normal network data rates apply to stream videos.</p>


</div>
<app-footer></app-footer>